module.exports = __webpack_public_path__ + "assets/img/shu_07.2068652b.png";